import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from '../../components/loader';

function LedgerReport() {

    const [loader, setLoader] = useState(false);
    const [orderData, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [productData, setProductData] = useState([]);
    const [eDate, setEDate] = useState(today);
    const [sDate, setSDate] = useState(today);
    const [filterdData, setFilteredData] = useState([]);
    const [dealerFilter, setDealerFilter] = useState([]);

    const filterDealer = () => {
        const filterData = orderData?.filter(order => order?.dealerData?.dealer.toLowerCase().includes(dealerFilter.toLowerCase()));
        //console.log(filterData);
        setFilteredData(filterData);
    };
    
    useEffect(()=> {
        filterDealer();
    },[dealerFilter]);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const formatSendDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const getData = async () => {
        setLoader(true);
        const sendData = {
            sDate: formatSendDate(sDate),
            eDate: formatSendDate(eDate)
        };

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/monthly-report/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            
            //console.log(response.data);
    
            if (response.data.status === "success") {
                setData(response.data.data);
                setFilteredData(response.data.data);
            } else {
                console.log("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
        setLoader(false);
    };

    const getProducts = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/products/all-product/', {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if(response.data.status === 'success'){
                setProductData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    useEffect(() => {
        getProducts();
        getData();
    }, [date]);
    

    const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    

    const exportToExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Daily Sales Report');
        XLSX.writeFile(wb, `Daily_Sales_Report_${formatDate(date)}.xlsx`);
    };


    const getItemDetails = (orderData, item) => {

        const itemData = orderData?.filter(items => items.itemId === item)[0];
        console.log(itemData);

        if(itemData){
            const weight = parseFloat(itemData?.qty) * parseFloat(itemData?.itemGrade) * parseFloat(itemData?.itemWeight/1000);
            const qty = parseFloat(itemData?.qty) * parseFloat(itemData?.itemGrade);
            const crates = parseFloat(itemData?.qty);
            const amount = parseFloat(itemData?.qty) * parseFloat(itemData?.itemGrade) * parseFloat(itemData?.itemPrice);

            const rData = {weight, qty, crates, amount};

            return rData;
        }else{
            return null;
        }
    };

    const productStates = {};

    productData?.forEach((product) => {
        productStates[`Crates${product?.id}`] = 0;
        productStates[`Qty${product?.id}`] = 0;
        productStates[`Weight${product?.id}`] = 0;
        productStates[`Amount${product?.id}`] = 0;
    });

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                 <div className="row" >
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <h4 className="box-title">Monthly Report</h4>
                                        <p className="mb-0 box-subtitle">Invoices</p>   
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
                                        <div className="input-group">
                                            <input
                                                type="date"
                                                value={formatDate(sDate)}
                                                onChange={(e) => setSDate(e.target.value)}
                                                className="form-control"
                                            />
                                    
                                            <input
                                                type="date"
                                                value={formatDate(eDate)}
                                                onChange={(e) => setEDate(e.target.value)}
                                                className="form-control"
                                            />
                                    
                                            <button class="btn btn-sm btn-success" onClick={getData} >Get Report</button>
                                        </div>
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <input className="form-control" value={dealerFilter} onChange={(e) => {setDealerFilter(e.target.value)}} placeholder="Enter Dealer Name..." />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <button className="btn btn-sm btn-warning" onClick={exportToExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>
                                </div>
                            </div>
                           
                    
                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th rowspan="2">Invoice Date</th>
                                                <th rowspan="2">Invoice No.</th>
                                                <th rowspan="2" className="border-r">Dealer</th>
                                                {productData?.map((product, index) => 
                                                    <th colSpan={4} key={index} className="border-r">{product.productName}</th>
                                                )}
                                            </tr>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: '25px', zIndex: 1, backgroundColor: '#f8f9fa' }}>
                                                {productData?.map((product, index) =>
                                                <>
                                                    <th>CRT</th>
                                                    <th>PKT</th>
                                                    <th>LTR/KG</th>
                                                    <th className="border-r">AMOUNT</th>
                                                </>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filterdData?.length > 0 ? (
                                                <>
                                                {filterdData.slice().reverse().map((item, index) => {
                                                    
                                                    return (
                                                    <tr key={index}>
                                                        <td data-t="s">{formatViewDate(item?.date)}</td>
                                                        <td>{`TRC/${item?.invoiceId}/${getFiscalYearLabel(new Date(item?.date))}`}</td>
                                                        <td className="border-r">{item?.dealerData?.dealer}</td>

                                                        {productData?.map((product, indexes) =>{
                                                                const itemData = getItemDetails(item?.orderData, product?.id);
                                                                productStates[`Crates${product?.id}`] += Number(itemData?.crates || 0);
                                                                productStates[`Qty${product?.id}`] += Number(itemData?.qty || 0);
                                                                productStates[`Weight${product?.id}`] += Number(itemData?.weight || 0);
                                                                productStates[`Amount${product?.id}`] += Number(itemData?.amount || 0);
                                                            return(
                                                                <>
                                                                    <td className="text-center">{Number(itemData?.crates) > 0 && Number(itemData?.crates).toFixed(2)}</td>
                                                                    <td className="text-center">{Number(itemData?.qty) > 0 && Number(itemData?.qty).toFixed(2)}</td>
                                                                    <td className="text-center">{Number(itemData?.weight) > 0 && Number(itemData?.weight).toFixed(2)}</td>
                                                                    <td className="text-center border-r">{Number(itemData?.amount) > 0 && Number(itemData?.amount).toFixed(2)}</td>
                                                                </>
                                                            )}
                                                        )}
                                                       
                                                    </tr>
                                                    )})}

                                                    <tr>
                                                        <th colSpan={3} className="border-r">Total</th>
                                                        {productData?.map((product, indexes) =>
                                                        <>
                                                            <th className="text-center">{Number(productStates[`Crates${product?.id}`]) > 0 && Number(productStates[`Crates${product?.id}`]).toFixed(2)}</th>
                                                            <th className="text-center">{Number(productStates[`Qty${product?.id}`]) > 0 && Number(productStates[`Qty${product?.id}`]).toFixed(2)}</th>
                                                            <th className="text-center">{Number(productStates[`Weight${product?.id}`]) > 0 && Number(productStates[`Weight${product?.id}`]).toFixed(2)}</th>
                                                            <th className="text-center border-r">{Number(productStates[`Amount${product?.id}`]) > 0 && Number(productStates[`Amount${product?.id}`]).toFixed(2)}</th>
                                                        </>
                                                        )}
                                                    </tr>
                                                    </>

                                                ) : (
                                                    <tr>
                                                        <td colSpan="17" className="text-center">No Data Available</td>
                                                    </tr>
                                            )}
                                       </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default LedgerReport;